export const MOCK_POTENTIAL_CLAIM_LOGS = [
  {
    id: 1,
    document_number: "CLAIM-POTENTIAL/38/2026/09/0007",
    doc_no: "CLAIM-POTENTIAL/38/2026/09/0007",
    publisher: "Mello Music",
    publisher_name: "Mello Music",
    dsp_name: "Facebook",
    dsp: "Facebook",
    total_streams_claimed: 251421,
    total_traffic: 251421,
    revenue_claimed: 88450000.0,
    total_revenue: 88450000.0,
    start_date: "2024-07-15T10:12:00Z",
    end_date: "2024-08-15T10:12:00Z",
    status: "finished",
    is_ccid_sent: false,
  },
  {
    id: 2,
    document_number: "CLAIM-POTENTIAL/38/2026/09/0006",
    doc_no: "CLAIM-POTENTIAL/38/2026/09/0006",
    publisher: "Mello Music",
    publisher_name: "Mello Music",
    dsp_name: "Facebook",
    dsp: "Facebook",
    total_streams_claimed: 200121,
    total_traffic: 200121,
    revenue_claimed: 72660000.0,
    total_revenue: 72660000.0,
    start_date: "2024-07-15T09:11:00Z",
    end_date: "2024-08-15T09:11:00Z",
    status: "canceled",
    is_ccid_sent: false,
  },
  {
    id: 3,
    document_number: "CLAIM-POTENTIAL/38/2026/09/0005",
    doc_no: "CLAIM-POTENTIAL/38/2026/09/0005",
    publisher: "Aquarius",
    publisher_name: "Aquarius",
    dsp_name: "Facebook",
    dsp: "Facebook",
    total_streams_claimed: 89311,
    total_traffic: 89311,
    revenue_claimed: 32670000.0,
    total_revenue: 32670000.0,
    start_date: "2024-07-15T07:21:00Z",
    end_date: "2024-08-15T07:21:00Z",
    status: "started",
    is_ccid_sent: false,
  },
  {
    id: 4,
    document_number: "CLAIM-POTENTIAL/38/2026/09/0004",
    doc_no: "CLAIM-POTENTIAL/38/2026/09/0004",
    publisher: "Nadaku",
    publisher_name: "Nadaku",
    dsp_name: "Youtube",
    dsp: "Youtube",
    total_streams_claimed: 120114,
    total_traffic: 120114,
    revenue_claimed: 42310000.0,
    total_revenue: 42310000.0,
    start_date: "2024-07-14T07:11:00Z",
    end_date: "2024-08-15T07:11:00Z",
    status: "finished",
    is_ccid_sent: false,
  },
  {
    id: 5,
    document_number: "CLAIM-POTENTIAL/38/2026/09/0003",
    doc_no: "CLAIM-POTENTIAL/38/2026/09/0003",
    publisher: "Aquarius",
    publisher_name: "Aquarius",
    dsp_name: "Spotify",
    dsp: "Spotify",
    total_streams_claimed: 201311,
    total_traffic: 201311,
    revenue_claimed: 62450000.0,
    total_revenue: 62450000.0,
    start_date: "2024-07-15T09:57:00Z",
    end_date: "2024-08-15T09:57:00Z",
    status: "started",
    is_ccid_sent: false,
  },
];

export const MOCK_PUBLISHERS = [
  { id: 1, name: "Mello Music", publisher_id: 1, publisher_name: "Mello Music" },
  { id: 2, name: "Aquarius", publisher_id: 2, publisher_name: "Aquarius" },
  { id: 3, name: "Nadaku", publisher_id: 3, publisher_name: "Nadaku" },
  { id: 4, name: "Musica Studio", publisher_id: 4, publisher_name: "Musica Studio" },
];

export const MOCK_DSPS = [
  { id: 1, dsp_id: 1, name: "Facebook", dsp_name: "Facebook" },
  { id: 2, dsp_id: 2, name: "Youtube", dsp_name: "Youtube" },
  { id: 3, dsp_id: 3, name: "Spotify", dsp_name: "Spotify" },
  { id: 4, dsp_id: 4, name: "Apple Music", dsp_name: "Apple Music" },
];

export const MOCK_DETAIL_CLAIM_LOG = {
  id: 1,
  document_number: "CLAIM-POTENTIAL/38/2026/09/0007",
  doc_no: "CLAIM-POTENTIAL/38/2026/09/0007",
  publisher: "Mello Music",
  publisher_name: "Mello Music",
  dsp: "Facebook",
  dsp_name: "Facebook",
  total_streams_claimed: 251421,
  total_traffic: 251421,
  revenue_claimed: 88450000.0,
  total_revenue: 88450000.0,
  status: "finished",
};

export const MOCK_CLAIMED_SONGS = [
  {
    id: 1,
    song_id: 101,
    song_title: "Cinta",
    isrc: "ISRC/XXV/20919412",
    isrc_code: "ISRC/XXV/20919412",
    traffic: 118917,
    total_traffic: 118917,
    revenue: 11450000,
    total_revenue: 11450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 2,
    song_id: 102,
    song_title: "Mereka",
    isrc: "ISRC/XXV/20919411",
    isrc_code: "ISRC/XXV/20919411",
    traffic: 38917,
    total_traffic: 38917,
    revenue: 2450000,
    total_revenue: 2450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 3,
    song_id: 103,
    song_title: "Kami",
    isrc: "ISRC/XXV/20919412",
    isrc_code: "ISRC/XXV/20919412",
    traffic: 18917,
    total_traffic: 18917,
    revenue: 1450000,
    total_revenue: 1450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 4,
    song_id: 104,
    song_title: "Saya",
    isrc: "ISRC/XXV/20919413",
    isrc_code: "ISRC/XXV/20919413",
    traffic: 48917,
    total_traffic: 48917,
    revenue: 3450000,
    total_revenue: 3450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 5,
    song_id: 105,
    song_title: "Dia",
    isrc: "ISRC/XXV/20919414",
    isrc_code: "ISRC/XXV/20919414",
    traffic: 18917,
    total_traffic: 18917,
    revenue: 1450000,
    total_revenue: 1450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 6,
    song_id: 106,
    song_title: "Iya",
    isrc: "ISRC/XXV/20919415",
    isrc_code: "ISRC/XXV/20919415",
    traffic: 17917,
    total_traffic: 17917,
    revenue: 1150000,
    total_revenue: 1150000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
];

export const MOCK_CLAIMED_SONGS_CHILDREN = [
  {
    id: 1,
    song_title: "Cinta Dia",
    isrc: "ISRC/XXV/20919413",
    isrc_code: "ISRC/XXV/20919413",
    traffic: 118917,
    total_traffic: 118917,
    revenue: 3450000,
    total_revenue: 3450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 2,
    song_title: "Cinta Anda",
    isrc: "ISRC/XXV/20919413",
    isrc_code: "ISRC/XXV/20919413",
    traffic: 18917,
    total_traffic: 18917,
    revenue: 11450000,
    total_revenue: 11450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 3,
    song_title: "Cinta",
    isrc: "ISRC/XXV/20919413",
    isrc_code: "ISRC/XXV/20919413",
    traffic: 18917,
    total_traffic: 18917,
    revenue: 1450000,
    total_revenue: 1450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 4,
    song_title: "Cinta",
    isrc: "ISRC/XXV/20919413",
    isrc_code: "ISRC/XXV/20919413",
    traffic: 18917,
    total_traffic: 18917,
    revenue: 3450000,
    total_revenue: 3450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
  {
    id: 5,
    song_title: "Cintaku",
    isrc: "ISRC/XXV/20919413",
    isrc_code: "ISRC/XXV/20919413",
    traffic: 18917,
    total_traffic: 18917,
    revenue: 1450000,
    total_revenue: 1450000,
    period_date: "27 Jul 2024 - 27 Aug 2024",
    period: "27 Jul 2024 - 27 Aug 2024",
  },
];
